import { useState, useEffect } from "react";
import { BreakpointSize } from "shared/styles/constants";

export const breakpointMatches = (breakpoint: BreakpointSize = BreakpointSize.m) =>
  window.matchMedia(`(max-width: ${breakpoint}px)`).matches;

export const useBreakpoint = (breakpoint: BreakpointSize = BreakpointSize.m) => {
  const [matches, setMatches] = useState(breakpointMatches(breakpoint));

  useEffect(() => {
    const updateMatches = () => {
      setMatches(breakpointMatches(breakpoint));
    };

    window.addEventListener("resize", updateMatches);

    // remove listener on unmount
    return () => {
      window.removeEventListener("resize", updateMatches);
    };
  });

  return matches;
};
